import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { RELOCATION_LAST_3_YEARS } from '../../../../../constants/Constants';

const styles = () => ({
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

class KeymanReferenceLink extends React.Component {
  renderLink = (source_url, source_name) => {
    const { classes } = this.props
    return (
      <span>
        参照：
        <a
          className={classes.link}
          href={source_url}
          target="_blank"
          rel="noopener"
          style={{ color: '#1A65FF' }}
          >
            {source_name}
          </a>
      </span>
    )
  }

  render () {
    const { item } = this.props;

    if (item && (item.source_url || item.is_hellowork)) {
      let source_name = ''
      const today = new Date();
      const threeYearsAgo = today.setFullYear(today.getFullYear() - RELOCATION_LAST_3_YEARS);
      const source_url = item.is_hellowork ? 'https://www.hellowork.mhlw.go.jp/' : item.source_url;
      if (source_url.indexOf('edinet-fsa') !== -1) {
        source_name = 'EDINET';
      } else if (item && item.is_hellowork) {
        // lintのエラーを回避するためにitemが存在するかどうかをチェック
        source_name = 'ハローワーク';
      } else {
        source_name = `${item.company_name}の人事異動情報`;
      }
      // 異動日が古いとリンク切れしている可能性があるため直近３年以上の異動日の場合はリンクを表示しない
      if (source_name === 'EDINET' || source_name === 'ハローワーク' || (source_name !== 'EDINET' && source_name !== 'ハローワーク' && Date.parse(item.relocation_at.date) > threeYearsAgo)) {
        return (
          <div style={{ fontSize: '11px', marginTop: '10px' }}>
            {this.renderLink(source_url, source_name)}
          </div>
        );
      }
    }

    return null;
  }
}

KeymanReferenceLink.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

PropTypes.defaultValue = {
  goToTimeline: null,
}

export default withStyles(styles)(KeymanReferenceLink);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/KeymanReferenceLink.jsx